import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Profession } from '../../models/profession.model';
import { ProfessionMockService } from '../../services/profession-mock.service';

@Component({
  selector: 'bwc-profession-detail',
  templateUrl: './profession-detail.component.html',
  styleUrls: ['./profession-detail.component.scss'],
})
export class ProfessionDetailComponent implements OnInit {
  profession: Profession | undefined;
  allProfessions: Profession[] = [];
  currentIndex = 0;
  isExpanded = false;
  isSaved = false;
  showTooltip: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private professionService: ProfessionMockService
  ) {}

  ngOnInit(): void {
    this.professionService.getProfessions().subscribe(professions => {
      this.allProfessions = professions;
      this.route.params.subscribe(params => {
        const id = Number(params['id']);
        this.currentIndex = this.allProfessions.findIndex(p => p.id === id);
        this.profession = this.allProfessions[this.currentIndex] || this.allProfessions[0];
        this.isSaved = this.professionService.getSavedIds().includes(this.profession?.id);
        this.isExpanded = false;
      });
    });
  }

  get displayedDescription(): string {
    if (!this.profession?.description) return '';
    if (this.isExpanded) return this.profession.description;
    return this.profession.description.length > 800
      ? this.profession.description.slice(0, 800) + '...'
      : this.profession.description;
  }

  get canGoPrevious(): boolean {
    return this.currentIndex > 0;
  }

  get canGoNext(): boolean {
    return this.currentIndex < this.allProfessions.length - 1;
  }

  goPrevious(): void {
    if (this.canGoPrevious) {
      this.router.navigate(['/profile-check/professions', this.allProfessions[this.currentIndex - 1].id]);
    }
  }

  goNext(): void {
    if (this.canGoNext) {
      this.router.navigate(['/profile-check/professions', this.allProfessions[this.currentIndex + 1].id]);
    }
  }

  toggleSave(): void {
    if (this.profession) {
      this.isSaved = this.professionService.toggleSaveProfession(this.profession);
    }
  }

  goBack(): void {
    this.router.navigate(['/profile-check/professions']);
  }
}
